import { VacancyPage } from '@pages/vacancy';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Профиль вакансии', 'Информация о вакансии');
}

export default VacancyPage;
